import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface SupportTextEditorProps {
    element: any
}

const SupportTextEditor: React.FC<SupportTextEditorProps> = (element) => {
    
    return (
      <>
        <div className="container-fluid support-text-editor spacer-top">
          {element?.element?.Content.replace(/^<p>|<\/p>$/g, "").startsWith("https://www.youtube.com") ?
          <p className="youtube-wrap mx-sm-5 mx-0">
            <iframe width="500" height="281" src={element?.element?.Content.replace(/^<p>|<\/p>$/g, "")} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </p>
          : <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{element?.element?.Content}</ReactMarkdown>}
        </div>
      </>
    );
};

export default SupportTextEditor;